import controller from './list-item-name.controller';
import template from './list-item-name.html';
import './list-item-name.scss';

export default {
	template,
	bindings:     {
		cell:       '<ngModel',
		onDownload: '&?',

		childsLoading: '<',
		childsLoaded: '<',
		isExpanded: '<',
	},
	controller,
	controllerAs: '$ctrl',
	require:      {
		ngModelCtrl: '?ngModel',
	},
};
